// Facebook Pixel Helper
// Відстежує cookie_consent перед ініціалізацією Facebook Pixel

const FB_PIXEL_ID = '2887729898233147';

declare global {
    interface Window {
        fbq?: any;
        _fbp?: string;
        _fbc?: string;
    }
}

/**
 * Отримує значення cookie за іменем
 */
function getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
    return null;
}

/**
 * Перевіряє, чи є параметр fbp_debug в URL (для тестування без cookie consent)
 */
function isDebugMode(): boolean {
    return window.location.search.includes('fbp_debug=true');
}

/**
 * Перевіряє, чи користувач дав згоду на cookies
 * Перевіряє cookie_consent cookie (який може бути встановлено на gallera.io з domain=.gallera.io)
 * Якщо є параметр fbp_debug=true в URL - повертає true (не перевіряє cookie consent)
 */
function hasCookieConsent(): boolean {
    // Якщо є debug режим - ігноруємо перевірку cookie consent
    if (isDebugMode()) {
        return true;
    }
    
    const cookieConsent = getCookie('cookie_consent');
    return cookieConsent === 'accepted';
}

/**
 * Ініціалізує Facebook Pixel (стандартний код від Facebook)
 */
function initFacebookPixel(): void {
    if (window.fbq && (window.fbq as any).loaded) {
        // Pixel вже ініціалізовано
        window.fbq('track', 'PageView');
        console.log('[Facebook Pixel] Pixel already initialized, tracking PageView');
        return;
    }

    // Ініціалізація з debug режимом для перевірки в консолі
    // У development режимі debug автоматично увімкнений
    // Або через параметр fbp_debug=true в URL
    const isDebug = process.env.NODE_ENV !== 'production' || isDebugMode();

    console.log('[Facebook Pixel] Initializing Pixel with ID:', FB_PIXEL_ID);
    console.log('[Facebook Pixel] Debug mode:', isDebug);
    
    // Стандартний код Facebook Pixel (точно як на gallera.io)
    // Це офіційний код від Facebook, тому вимикаємо ESLint правила
    /* eslint-disable prefer-spread, prefer-rest-params */
    (function(f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
        if (f.fbq) return;
        n = f.fbq = function() {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        
        // Додаємо onload обробник ПЕРЕД вставкою скрипта в DOM
        t.onload = function() {
            console.log('[Facebook Pixel] ✅ Script fbevents.js loaded successfully!');
            
            // Після завантаження скрипта він автоматично обробить чергу
            // Перевіряємо через трохи часу, чи обробилася черга
            setTimeout(() => {
                const hasCallMethod = typeof (window.fbq as any)?.callMethod !== 'undefined';
                const queue = (window.fbq as any)?.queue || [];
                const isLoaded = (window.fbq as any)?.loaded;
                
                console.log('[Facebook Pixel] After script load:');
                console.log('  - fbq.callMethod:', hasCallMethod ? '✅ available' : '❌ NOT available');
                console.log('  - fbq.loaded:', isLoaded);
                console.log('  - queue length:', queue.length);
                
                if (queue.length > 0 && hasCallMethod) {
                    console.log('[Facebook Pixel] Queue should process automatically...');
                } else if (queue.length === 0 && hasCallMethod) {
                    console.log('[Facebook Pixel] ✅ Queue processed successfully!');
                } else if (!hasCallMethod) {
                    console.error('[Facebook Pixel] ❌ Script loaded but callMethod still not available!');
                    console.error('[Facebook Pixel] This may indicate a problem with the script execution.');
                }
            }, 500);
        };
        
        t.onerror = function() {
            console.error('[Facebook Pixel] ❌ Error loading script fbevents.js!');
            console.error('[Facebook Pixel] Check network tab for failed request to connect.facebook.net');
            console.error('[Facebook Pixel] Possible causes: ad blocker, network error, CORS issue');
        };
        
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
        
        // Викликаємо init та track одразу - вони додадуться в чергу
        // і автоматично виконаються після завантаження скрипта
        console.log('[Facebook Pixel] Queuing init and track events...');
        n('init', FB_PIXEL_ID, {
            autoConfig: true,
            debug: isDebug
        });
        n('track', 'PageView');
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', 0, 0, 0);
    /* eslint-enable prefer-spread, prefer-rest-params */
    
    // Перевіряємо через 3 секунди, чи скрипт завантажився і обробив чергу
    setTimeout(() => {
        const queue = (window.fbq as any)?.queue || [];
        const hasCallMethod = typeof (window.fbq as any)?.callMethod !== 'undefined';
        const isLoaded = (window.fbq as any)?.loaded;
        
        console.log('[Facebook Pixel] ===== 3 Second Check =====');
        console.log('  - fbq.callMethod:', hasCallMethod ? '✅ available' : '❌ NOT available');
        console.log('  - fbq.loaded:', isLoaded);
        console.log('  - queue length:', queue.length);
        console.log('  - queue:', queue);
        
        if (!hasCallMethod) {
            console.error('[Facebook Pixel] ❌ Script did not load properly!');
            console.error('[Facebook Pixel] Possible causes:');
            console.error('  1. Ad blocker blocking connect.facebook.net');
            console.error('  2. Network error loading fbevents.js');
            console.error('  3. CORS issue');
            console.error('[Facebook Pixel] Check Network tab for fbevents.js request');
        } else if (queue.length > 0) {
            console.warn('[Facebook Pixel] ⚠️ Queue still has items. Script may not be processing them.');
            console.warn('[Facebook Pixel] Try: forceProcessQueue()');
        } else {
            console.log('[Facebook Pixel] ✅ Everything looks good!');
        }
        console.log('[Facebook Pixel] =========================');
    }, 3000);


    if (isDebug) {
        console.log('[Facebook Pixel] Initialized with debug mode. Use fbq("track", "PageView") in console to test.');
        console.log('[Facebook Pixel] Use checkFbPixel() to check Pixel status');
        if (isDebugMode()) {
            console.log('[Facebook Pixel] Debug mode active - cookie consent check is bypassed');
        }
    }

    // Додаємо fallback зображення для відстеження при вимкненому JavaScript
    const appendFallbackPixel = () => {
        if (document.getElementById('fb-pixel-image')) {
            return;
        }

        const img = document.createElement('img');
        img.id = 'fb-pixel-image';
        img.height = 1;
        img.width = 1;
        img.style.display = 'none';
        img.src = `https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`;
        document.body.appendChild(img);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', appendFallbackPixel, { once: true });
    } else {
        appendFallbackPixel();
    }
}

/**
 * Завантажує Facebook Pixel, якщо є згода на cookies або активний debug режим
 */
export function loadFacebookPixel(): void {
    console.log('[Facebook Pixel] loadFacebookPixel called');
    console.log('[Facebook Pixel] Cookie consent:', hasCookieConsent());
    console.log('[Facebook Pixel] Debug mode:', isDebugMode());
    
    if (hasCookieConsent() || isDebugMode()) {
        console.log('[Facebook Pixel] Loading Pixel...');
        initFacebookPixel();
    } else {
        console.log('[Facebook Pixel] Pixel not loaded - no cookie consent and debug mode is off');
    }
}

/**
 * Перевіряє cookie consent та завантажує Pixel при зміні
 */
export function checkAndLoadFacebookPixel(): void {
    loadFacebookPixel();

    // Слухаємо зміни cookie_consent (на випадок якщо змінюється після завантаження сторінки)
    const checkInterval = setInterval(() => {
        if (hasCookieConsent() && (!window.fbq || !window.fbq.loaded)) {
            initFacebookPixel();
            clearInterval(checkInterval);
        }
    }, 1000);

    // Зупиняємо перевірку через 60 секунд
    setTimeout(() => clearInterval(checkInterval), 60000);
}

/**
 * Відстежує подію Facebook Pixel
 * @param eventName - назва події (наприклад, 'InitiateCheckout', 'CompleteRegistration')
 * @param params - додаткові параметри події
 */
export function trackFacebookEvent(eventName: string, params?: Record<string, any>): void {
    if (hasCookieConsent() && window.fbq) {
        if (params) {
            window.fbq!('track', eventName, params);
        } else {
            window.fbq!('track', eventName);
        }
        
        // Логування для debug (в development або з fbp_debug=true)
        if (process.env.NODE_ENV !== 'production' || isDebugMode()) {
            console.log(`[Facebook Pixel] Tracked event: ${eventName}`, params || {});
        }
    } else if (!hasCookieConsent() && !isDebugMode()) {
        console.log(`[Facebook Pixel] Event ${eventName} skipped - no cookie consent`);
    } else if (!window.fbq) {
        console.log(`[Facebook Pixel] Event ${eventName} skipped - Pixel not initialized`);
    }
}

/**
 * Отримує _fbp cookie (Facebook Browser ID) для передачі на сервер
 */
export function getFacebookBrowserId(): string | null {
    return getCookie('_fbp') || null;
}

/**
 * Отримує _fbc cookie (Facebook Click ID) для передачі на сервер
 */
export function getFacebookClickId(): string | null {
    return getCookie('_fbc') || null;
}

/**
 * Отримує дані Facebook для передачі на сервер
 */
export function getFacebookPixelData(): {
    _fbp: string | null;
    _fbc: string | null;
} {
    return {
        _fbp: getFacebookBrowserId(),
        _fbc: getFacebookClickId(),
    };
}

/**
 * Форсує обробку черги Facebook Pixel (на випадок, якщо скрипт завантажився, але не обробив чергу)
 */
export function forceProcessQueue(): void {
    if (!window.fbq) {
        console.error('[Facebook Pixel] Cannot process queue - fbq not defined');
        return;
    }
    
    const queue = (window.fbq as any)?.queue || [];
    if (queue.length === 0) {
        console.log('[Facebook Pixel] Queue is empty');
        return;
    }
    
    console.log('[Facebook Pixel] Force processing queue with', queue.length, 'items');
    
    // Спробуємо викликати track - це може заставити скрипт обробити чергу
    try {
        window.fbq!('track', 'PageView');
        console.log('[Facebook Pixel] Track called, queue should process now');
        
        // Перевіряємо через секунду
        setTimeout(() => {
            const newQueue = (window.fbq as any)?.queue || [];
            if (newQueue.length < queue.length) {
                console.log('[Facebook Pixel] Queue processed! Remaining items:', newQueue.length);
            } else {
                console.warn('[Facebook Pixel] Queue still not processed. Items:', newQueue.length);
                console.warn('[Facebook Pixel] Script may not be loaded. Check network tab for fbevents.js');
            }
        }, 1000);
    } catch (e) {
        console.error('[Facebook Pixel] Error processing queue:', e);
    }
}

/**
 * Діагностична функція для перевірки стану Facebook Pixel
 * Використовуйте в консолі: checkFbPixel()
 */
export function checkFbPixel(): void {
    console.log('[Facebook Pixel] ===== Status Check =====');
    console.log('  - fbq defined:', typeof window.fbq !== 'undefined');
    console.log('  - fbq loaded:', (window.fbq as any)?.loaded);
    console.log('  - cookie consent:', hasCookieConsent());
    console.log('  - debug mode:', isDebugMode());
    console.log('  - Pixel ID:', FB_PIXEL_ID);
    
    if (window.fbq) {
        const queue = (window.fbq as any)?.queue || [];
        console.log('  - fbq queue length:', queue.length);
        console.log('  - fbq queue:', queue);
        console.log('  - fbq version:', (window.fbq as any)?.version);
        console.log('  - fbq callMethod:', typeof (window.fbq as any)?.callMethod);
        
        // Перевіряємо, чи скрипт в DOM
        const scriptElement = document.querySelector('script[src*="fbevents.js"]');
        console.log('  - Script element in DOM:', scriptElement ? 'YES' : 'NO');
        
        if (scriptElement) {
            console.log('  - Script src:', (scriptElement as HTMLScriptElement).src);
            console.log('  - Script loaded:', (scriptElement as HTMLScriptElement).onload ? 'has onload handler' : 'no onload');
        }
        
        // Якщо є черга, але скрипт не завантажився - показуємо попередження
        if (queue.length > 0 && !(window.fbq as any)?.loaded) {
            console.warn('  - ⚠️ WARNING: Queue has items but script not loaded!');
            console.warn('  - Use forceProcessQueue() to try processing queue');
        }
    } else {
        console.log('  - ERROR: fbq is not defined. Pixel may not be initialized.');
    }
    console.log('[Facebook Pixel] ========================');
    
    // Експортуємо для глобального використання
    (window as any).checkFbPixel = checkFbPixel;
    (window as any).forceProcessQueue = forceProcessQueue;
}

